import { Injectable } from "@angular/core";
import { PessoaFisica } from "@tivic-team/manager-ts/dist/grl";
import { PessoaFisicaDTO } from "app/model/dtos/grl/pessoa-fisica.dto";
import { HttpGet, HttpResponse, JSONData, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";


@Injectable()
export class PessoaFisicaController {
    constructor() {}

    async find(filtros?: IFilter): Promise<Array<PessoaFisica>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/pessoafisica',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<PessoaFisica>()
            )
        );

        return await quark.call();
    }

    async getPessoaByCPF(nrCpf: String): Promise<PessoaFisicaDTO>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/pessoafisica/:nrCpf',
                    environment: environment,
                    pathParams: new JSONData({nrCpf: nrCpf})
                }),
            }),
            new HttpResponse(
                new PessoaFisicaDTO()
            )
        );

        return quark.call();
    }

    async getMotoristas(filtros?: IFilter): Promise<Array<PessoaFisica>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'grl/pessoafisica/motoristas',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<PessoaFisica>()
            )
        );

        return await quark.call();
    }
}